import script from "./Documents.vue?vue&type=script&lang=ts&setup=true"
export * from "./Documents.vue?vue&type=script&lang=ts&setup=true"

import "./Documents.vue?vue&type=style&index=0&id=bb9cab32&lang=css"

const __exports__ = script;

export default __exports__